/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
// we need to use tabindex on popup ^^ so it could be interactable right away
// when it's appears
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { usePopupContext } from '../../common/contexts/PopupContext';
import { handleEnterKeyPress } from '../../common/popups/utils';

const StudentNonExpandableWrapper = ({
    children,
    studentKey,
    studentId,
    nonExpandableApplicationName,
}) => {
    const {
        actions: { showGradeNotAvailablePopup },
    } = usePopupContext();

    const handleGradeNotAvailablePopupClick = useCallback(
        () => showGradeNotAvailablePopup({ nonExpandableApplicationName }),
        [nonExpandableApplicationName, showGradeNotAvailablePopup],
    );

    return (
        <div
            className='dashboard-students-list-item'
            data-student-id={studentId}
            key={studentKey}
            onClick={handleGradeNotAvailablePopupClick}
            onKeyDown={handleEnterKeyPress}
            tabIndex={0}
        >
            {children}
        </div>
    );
};

StudentNonExpandableWrapper.propTypes = {
    children: PropTypes.node,
    studentKey: PropTypes.string.isRequired,
    studentId: PropTypes.string,
    nonExpandableApplicationName: PropTypes.string,
};

StudentNonExpandableWrapper.defaultProps = {
    children: null,
    studentId: '',
    nonExpandableApplicationName: '',
};

export default StudentNonExpandableWrapper;
